/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MaintenanceRequestBySerialNumberResponse { 
    id: string;
    createdDate: string;
    finishedDate?: string | null;
    status: string;
    maintenanceType: string;
    facilityName?: string | null;
    containerNumber?: number | null;
    rackNumber?: number | null;
    placeNumber?: number | null;
    equipmentModelName?: string | null;
    serialNumber: string;
    serviceCenterName: string;
    error: string;
    workerName?: string | null;
    warrantyType: string;
}

